import { motion } from "framer-motion";
import { Reveal, MaskLine } from "@/components/Reveal";

// Reusable service section with numbered cards.
export const ServiceGrid = ({ id, label, title, titleAccent, intro, items, testId }) => (
  <section id={id} data-testid={testId} className="relative py-28 sm:py-36 border-t border-white/5">
    <div className="max-w-screen-2xl mx-auto px-6 sm:px-10">
      <div className="grid lg:grid-cols-12 gap-10 items-end mb-16">
        <div className="lg:col-span-8">
          <Reveal><p className="label mb-6">{label}</p></Reveal>
          <h2 className="font-serif font-light text-4xl sm:text-6xl lg:text-7xl tracking-tight uppercase leading-[0.98]">
            <MaskLine>{title}</MaskLine>
            {titleAccent && <MaskLine delay={0.08} className="text-[#d4c4a8] italic">{titleAccent}</MaskLine>}
          </h2>
        </div>
        {intro && (
          <Reveal delay={0.1} className="lg:col-span-4">
            <p className="font-body text-[#a1a1aa] leading-relaxed">{intro}</p>
          </Reveal>
        )}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {items.map((it, i) => (
          <motion.div
            key={it}
            data-testid={`${testId}-item-${i}`}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: (i % 4) * 0.06, ease: [0.22, 1, 0.36, 1] }}
            className="hover-card group relative bg-[#111111] border border-white/10 p-7 min-h-[180px] flex flex-col justify-between"
          >
            <span className="font-serif text-2xl text-[#3a3a3a] group-hover:text-[#d4c4a8] transition-colors duration-500">
              {String(i + 1).padStart(2, "0")}
            </span>
            <h3 className="font-display uppercase tracking-[0.12em] text-sm sm:text-base text-[#fafafa] leading-snug mt-8">
              {it}
            </h3>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
